export default (options) => ({
  componentName: 'cell-money',
  componentArgs: {
    toFixed: options?.toFixed ?? 0,
    trimFraction: options?.trimFraction ?? false,
  },
});
